export type AccessTokenWriter = {
  saveAccessToken: (token: string) => void;
};

export const extractAccessTokenFromWindowLocation = (window?: Window) => {
  if (!window?.location?.href || typeof window.location.href !== "string") {
    return;
  }

  let token: string | undefined;

  const replacer = (substring: string, arg: string): string => {
    token = arg;
    return substring;
  };

  window.location.href.replace(/access_token=([^&]+)/u, replacer);

  return token;
};

export const configureAccessToken = <T extends AccessTokenWriter>(window: Window | undefined, storage: T) => {
  const urlToken = extractAccessTokenFromWindowLocation(window);

  if (urlToken) {
    storage.saveAccessToken(urlToken);
  }

  return storage;
};
